import DashboardPageLayout from "../pages/dashboard/DashboardPageLayout";
import HomePage from "../pages/home/HomePage";
import { RouteType } from "./config";
import DefaultPage from "../pages/dashboard/DefaultPage";
import DashboardIndex from "../pages/dashboard/DashboardIndex";
import ChangelogPage from "../pages/changelog/ChangelogPage";
import AnalyticsPage from "../pages/dashboard/AnalyticsPage";
import SaasPage from "../pages/dashboard/SaasPage";
import ComponentPageLayout from "../pages/component/ComponentPageLayout";
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import HomeIcon from '@mui/icons-material/Home';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import EggIcon from '@mui/icons-material/Egg';
import ParkIcon from '@mui/icons-material/Park';


import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import AlertPage from "../pages/component/AlertPage";
import ButtonPage from "../pages/component/ButtonPage";
import InstallationPage from "../pages/installation/InstallationPage";
import DocumentationPage from "../pages/documentation/DocumentationPage";
import TrasportiPageLayout from "../pages/trasporti/TrasportiPageLayout";
import AnagraficaTrasportiPage from "../pages/trasporti/AnagraficaTrasporti";
import CalendarioTrasportiPage from "../pages/trasporti/CalendarioTrasporti";
import CamereCasaAmelia from "../pages/casaAmelia/CamereCasaAmelia";
import CasaAmeliaPageLayout from "../pages/casaAmelia/CasaAmeliaPageLayout";

const appRoutes: RouteType[] = [
  {
    index: true,
    element: <HomePage />,
    state: "home"
  },
  {
    path: "/dashboard",
    element: <DashboardPageLayout />,
    state: "dashboard",
    sidebarProps: {
      displayText: "Campagna Natale",
      icon: <ParkIcon />
    },
    child: [
      {
        index: true,
        element: <DashboardIndex />,
        state: "dashboard.index"
      },
      {
        path: "/dashboard/default",
        element: <DefaultPage />,
        state: "dashboard.default",
        sidebarProps: {
          displayText: "Anno 2022"
        },
      },
      {
        path: "/dashboard/analytics",
        element: <AnalyticsPage />,
        state: "dashboard.analytics",
        sidebarProps: {
          displayText: "Anno 2023"
        }
      },
      {
        path: "/dashboard/saas",
        element: <SaasPage />,
        state: "dashboard.saas",
        sidebarProps: {
          displayText: "Anno 2024"
        }
      }
    ]
  },
  {
    path: "/component",
    element: <ComponentPageLayout />,
    state: "component",
    sidebarProps: {
      displayText: "Campagna Pasqua",
      icon: <EggIcon />
    },
    child: [
      {
        path: "/component/alert",
        element: <AlertPage />,
        state: "component.alert",
        sidebarProps: {
          displayText: "Anno 2022"
        },
      },
      {
        path: "/component/button",
        element: <ButtonPage />,
        state: "component.button",
        sidebarProps: {
          displayText: "Anno 2023"
        }
      },
      {
        path: "/component/button",
        element: <ButtonPage />,
        state: "component.button",
        sidebarProps: {
          displayText: "Anno 2024"
        }
      }
    ]
  },
  {
    path: "/trasporti",
    element: <TrasportiPageLayout />,
    state: "documentation",
    sidebarProps: {
      displayText: "Trasporti",
      icon: <DirectionsCarIcon />
    },
    child: [
      {
        path: "/trasporti/anagrafica",
        element: <AnagraficaTrasportiPage />,
        state: "trasporti.anagrafica",
        sidebarProps: {
          displayText: "Anagrafica"
        },
      },
      {
        path: "/trasporti/calendario",
        element: <CalendarioTrasportiPage />,
        state: "trasporti.calendario",
        sidebarProps: {
          displayText: "Calendario"
        },
      }
    ]
  },
  {
    path: "/casaamelia",
    element: <CasaAmeliaPageLayout />,
    state: "casaamelia",
    sidebarProps: {
      displayText: "Casa Amelia",
      icon: <HomeIcon />
    },
    child: [
      {
        path: "/casaamelia/camere",
        element: <CamereCasaAmelia />,
        state: "casaamelia.camere",
        sidebarProps: {
          displayText: "Camere"
        }
      }
    ]
  }
];

export default appRoutes;